/* Khắc tên (engraving) — PDP modal.
   Validates the message (12 chars, A-Z a-z 0-9 . - ! '), previews it over the
   bottle, and writes it into the hidden line item property once confirmed.
   The hidden input stays disabled until then, so nothing empty is submitted. */
(function () {
  // Copy comes from window.yslI18n (rendered by snippets/ysl-i18n-js.liquid) because a
  // .js asset cannot run Liquid's `t` filter. The literal stays as the fallback, so a
  // missing key degrades to the Vietnamese copy instead of to an empty string.
  function T(k, fallback) { var d = window.yslI18n; return (d && d[k]) || fallback; }

  var ALLOWED = /^[A-Za-z0-9 .\-!']*$/;

  function init(root) {
    if (root.dataset.engBound) return;
    root.dataset.engBound = '1';

    var max = parseInt(root.dataset.max, 10) || 12;
    var input = root.querySelector('[data-eng-input]');
    var modal = root.querySelector('[data-eng-modal]');
    var field = root.querySelector('[data-eng-field]');
    var preview = root.querySelector('[data-eng-preview]');
    var count = root.querySelector('[data-eng-count]');
    var err = root.querySelector('[data-eng-err]');
    var consent = root.querySelector('[data-eng-consent]');
    var confirm = root.querySelector('[data-eng-confirm]');
    var chip = root.querySelector('[data-eng-chip]');
    var chipVal = root.querySelector('[data-eng-chip-val]');
    var opener = root.querySelector('[data-eng-open]');
    var lastFocus = null;

    function message() {
      return (field.value || '').trim();
    }

    function validate() {
      var v = message();
      var problem = '';
      if (v.length > max) problem = T('engErrMax', 'Tối đa %n% ký tự.').replace('%n%', max);
      else if (!ALLOWED.test(v)) problem = T('engErrCharset', "Chỉ dùng chữ A-Z, a-z, số và ký tự . - ! '");

      if (count) count.textContent = v.length + '/' + max;
      if (err) {
        err.textContent = problem;
        err.hidden = !problem;
      }
      if (preview) preview.textContent = v;
      confirm.disabled = !!problem || !v.length || !consent.checked;
      return !problem && !!v.length;
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      validate();
      window.setTimeout(function () { field.focus(); }, 0);
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function apply(value) {
      if (value) {
        input.value = value;
        input.disabled = false;
        if (chipVal) chipVal.textContent = value;
        if (chip) chip.hidden = false;
        if (opener) opener.hidden = true;
      } else {
        input.value = '';
        input.disabled = true;
        if (chip) chip.hidden = true;
        if (opener) opener.hidden = false;
      }
    }

    field.addEventListener('input', validate);
    consent.addEventListener('change', validate);

    /* A bare text input inside the product form submits it on Enter — that would
       add to cart from the modal. */
    field.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (!confirm.disabled) confirm.click();
      }
    });

    root.querySelectorAll('[data-eng-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    if (opener) opener.addEventListener('click', open);

    var edit = root.querySelector('[data-eng-edit]');
    if (edit) edit.addEventListener('click', open);

    var clear = root.querySelector('[data-eng-clear]');
    if (clear) clear.addEventListener('click', function () {
      field.value = '';
      consent.checked = false;
      validate();
      apply('');
    });

    var reset = root.querySelector('[data-eng-reset]');
    if (reset) reset.addEventListener('click', function () {
      field.value = '';
      consent.checked = false;
      validate();
      field.focus();
    });

    confirm.addEventListener('click', function () {
      if (!validate() || !consent.checked) return;
      apply(message().toUpperCase());
      close();
    });

    validate();
  }

  function boot() {
    document.querySelectorAll('[data-engrave]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
